import { makeStyles } from '@material-ui/core'

export const useIconStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.primary.main,
    backgroundColor: 'white',
    zIndex: 1,
    width: 22,
    height: 22,
    display: 'flex',
    borderRadius: '50%',
    borderColor: theme.palette.primary.main,
    border: '1px solid',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 12
  },
  green: {
    color: '#1B9D6B',
    borderColor: '#1B9D6B',
    backgroundColor: '#1B9D6B'
  },
  red: {
    color: 'red',
    borderColor: 'red'
  }
}))

export const trackingStepColors = makeStyles(() => ({
  success: {
    backgroundColor: '#1B9D6B',
    borderColor: '#1B9D6B'
  },
  green: {
    borderColor: '#8ECFA7',
    backgroundColor: '#8ECFA7'
  },
  yellow: {
    borderColor: '#F4CE5D',
    backgroundColor: '#F4CE5D'
  },
  orange: {
    borderColor: '#FFAA72',
    backgroundColor: '#FFAA72'
  },
  purple: {
    borderColor: '#A4AAFB',
    backgroundColor: '#A4AAFB'
  },
  red: {
    borderColor: '#FE9891',
    backgroundColor: '#FE9891'
  },
  blue: {
    borderColor: '#9FCFFF',
    backgroundColor: '#9FCFFF'
  },
  gray: {
    borderColor: '#7D7F82',
    backgroundColor: '#7D7F82'
  }
}))
